import React from "react";
import { FormGroup, Label } from "reactstrap";
import withStyles from "isomorphic-style-loader/withStyles";
import s from "./styles.scss";
import Select from "react-select";
import { brandSelectTheme } from "./theme";

interface Props {
  name: string;
  id: string;
  placeholder?: string;
  label?: string;
  value: string | number | Date;
  dataElmId: string;
  onChange: (string: string) => void;
  onBlur: any;
  errors: Array<string>;
  options: Array<{
    label: string;
    value: string | number;
  }>;
  disabled: boolean;
  isMulti: boolean;
}

class BaseSelect extends React.Component<Props, void> {
  static defaultProps = {
    errors: [],
  };

  render() {
    const {
      id,
      name,
      value,
      label,
      placeholder,
      dataElmId,
      options,
      errors,
      disabled,
      isMulti,
    } = this.props;

    return (
      <FormGroup className={s.formGroup}>
        {label && (
          <Label
            data-elm-id={`${dataElmId}_label`}
            className={s.label}
            for={id}
          >
            {label}
          </Label>
        )}
        <Select
          id={id}
          name={name}
          placeholder={placeholder}
          value={value}
          dataElmId={`${dataElmId}`}
          onChange={this.props.onChange}
          errors={errors}
          disabled={disabled}
          isDisabled={disabled}
          options={options}
          isMulti={isMulti}
          className={s.select}
          classNamePrefix="react-select"
          theme={brandSelectTheme}
        />
        {errors && (
          <ul className={s.errorSpan}>
            {errors.map((message, index) => (
              <li data-elm-id={`${dataElmId}_error_message`} key={index}>
                {message}
              </li>
            ))}
          </ul>
        )}
      </FormGroup>
    );
  }
}

export default withStyles(s)(BaseSelect);
